'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var BaseDeviceListView = require('components/devices/views/common/base_device_list_view');
var DeviceController = require('components/devices/devices_controller');
var i18n = require('utils/i18n');
var Lock = require('components/common/behaviors/lock');
var Misc = require('utils/misc');

var SubDeviceListView = BaseDeviceListView.extend({
    events: function () {
        return _.extend({}, BaseDeviceListView.prototype.events(), {
            'click div.js-tab-btn-scan': 'scanDevices',
            'click div.js-tab-btn-invite': 'invite',
        });
    },

    behaviors: {
        lock: {
            behaviorClass: Lock,
            buttons: ['#js-delete', '#js-add', '#js-scan', '#js-write', '#js-config'],

            getDeviceID: function (view) {
                return view.parentDevice.id;
            },
        },
    },

    additionalColumns: [{ id: '#_category', name: 'Gerät' }], // i18n.TR('Gerät')

    getTableConfiguration: function () {
        var isArchived = AppState.getDeviceInfo(this.parentDevice.id).status === Consts.DeviceStatus.Archived;
        var selectionButtons;
        if (isArchived) {
            selectionButtons = [
                { ButtonText: i18n.TR('Freigeben'), ButtonID: 'invite', ButtonIcon: 'md md-group' },
                { ButtonText: i18n.TR('Labels'), ButtonID: 'group', ButtonIcon: 'fa fa-tags' },
            ];
        } else {
            selectionButtons = [
                { ButtonText: i18n.TR('Freigeben'), ButtonID: 'invite', ButtonIcon: 'md md-group' },
                { ButtonText: i18n.TR('Labels'), ButtonID: 'group', ButtonIcon: 'fa fa-tags' },
                { ButtonText: i18n.TR('Alarm'), ButtonID: 'alarm', ButtonIcon: 'fa fa-bell-o' },
                {
                    ButtonText: i18n.TR('Werte auswählen'),
                    ButtonID: 'config',
                    ButtonIcon: 'glyphicon glyphicon-cloud-upload',
                },
                { ButtonText: i18n.TR('Wert schreiben'), ButtonID: 'write', ButtonIcon: 'glyphicon glyphicon-pencil' },
            ];
        }

        var config = {
            title: i18n.TR('Angeschlossene Geräte'),
            columns: AppState.selectedColumns(this.deviceCategory),
            hasRefreshButton: true,
            hasSelectionButtons: true,
            customButtons: [],
            selectionButtons: selectionButtons,
            CSVLink: '/api/v1/devices?parent=' + this.parentDevice.id + '&format=csv&filename=' + this.getCSVFileName(),
        };

        if (AppState.hasCompanyPermission(Consts.PermissionsCompany.RemoveDevices)) {
            config.selectionButtons.push({
                ButtonText: i18n.TR('Löschen'),
                ButtonID: 'delete',
                ButtonIcon: 'fa fa-trash',
            });
        }

        if (AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices) && !isArchived) {
            config.customButtons = [
                { ButtonText: i18n.TR('Automatische Erkennung'), ButtonID: 'scan' },
                { ButtonIcon: 'fa fa-plus', ButtonID: 'add' },
            ];
        }

        return config;
    },

    getAddDeviceConfiguration: function () {
        return this.addDeviceConfig;
    },

    scanDevices: function (e) {
        e.preventDefault();
        DeviceController.detectSubDevices({
            controller: this.controller,
            parentDevice: this.parentDevice,
        });
    },
});

module.exports = SubDeviceListView;
